import useAlert from './useAlert'
import useCreateAffiliation from './useCreateAffiliation'
import useFormFields from './useFormFields'
import useSubmitBtns from './useSubmitBtns'
import useAffiliationField from './useAffiliationField'
import useEditAffiliation from './useEditAffiliation'

export default { useAffiliationField, useEditAffiliation, useSubmitBtns, useAlert, useCreateAffiliation, useFormFields }